import { render, staticRenderFns } from "./GeneralInvoiceStatistics.vue?vue&type=template&id=10dda56e&scoped=true&"
import script from "./GeneralInvoiceStatistics.vue?vue&type=script&lang=ts&"
export * from "./GeneralInvoiceStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInvoiceStatistics.vue?vue&type=style&index=0&id=10dda56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dda56e",
  null
  
)

export default component.exports